import React from 'react'
import styled from '@emotion/styled'
import BasicButton from '../../generic/button'

import { fontSizeMedium, fontSize3XSmall, fontWeightBold, grayLight20 } from '../../../constants/principles'
import { breakpoints } from '../../../constants'

export default ({ header, subheader, kbbUrl }) => (
  <StepDiv data-testid={`oc-step-shop-your-next-car`}>
    <Header>{header}</Header>
    <Subheader>{subheader}</Subheader>
    <BasicButton data-testid={`oc-btn-start-browsing`} secondary={true} onClick={() => (window.location.href = `${kbbUrl}/new-cars/`)}>
      Start Browsing
    </BasicButton>
  </StepDiv>
)

const StepDiv = styled.div`
  text-align: center;
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    width: 50%;
    border-bottom: initial;
    padding-bottom: initial;
  }
  border-bottom: 1px solid ${grayLight20};
  padding-bottom: 32px;
  padding-left: 8px;
`

const Header = styled.div`
  font-size: ${fontSizeMedium};
  font-weight: ${fontWeightBold};
  padding-top: 32px;
`
const Subheader = styled.div`
  font-size: ${fontSize3XSmall};
  padding-bottom: ${p => (p.padding ? p.padding : `16px`)};
`
